import { t } from "../../common/miscellaneous/t";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { useOrderValueData } from "../hooks/useOrderValueData";
import { useSettingsValueData } from "../hooks/useSettingsValueData";

export function setupPageTitle(pathname: string) {
  // Check partner is enable allow samples.
  const settings = useSettingsValueData();
  const isAllowSample = settings.data.sampleOptions?.allowSamples;

  // Check order is exists a sample part.
  const orders = useOrderValueData();
  const isExistsSampleParts =
    orders.tag === "ready" &&
    orders.data.orderLines?.some((line) => !!line.isSample);

  switch (pathname) {
    case `${getPartnerPathnameClient(true)}/address`:
      return `/ ${t("mk-hc-shipping-address")}`;
    case `${getPartnerPathnameClient(true)}/shipping`:
      return `/ ${t("mk-hc-shipping-options")}`;
    case `${getPartnerPathnameClient(true)}/sample-questions`:
      return (isAllowSample && isExistsSampleParts) ? `/ ${t("mk-hc-sample-questionnaire")}` : "";
    case `${getPartnerPathnameClient(true)}/confirm`:
      return `/ ${t("mk-hc-order-preview")}`;
    case `${getPartnerPathnameClient(true)}/payment/billing`:
    case `${getPartnerPathnameClient(true)}/payment/card/entry`:
    case `${getPartnerPathnameClient(true)}/payment/card/saved`:
      return `/ ${t("mk-hc-payment")}`;
    default:
      return "";
  }
}
